import store from '../store'

export default {
    hasSubscription(){
        
    }
}